"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newsletterSubscribeCookieValue = exports.newsletterSubscribeCookieKey = exports.newsletterPopupCookieValue = exports.newsletterPopupCookieKey = exports.cookieExpireDays = void 0;
const newsletterPopupCookieKey = exports.newsletterPopupCookieKey = 'NewsletterPopupShow';
const newsletterPopupCookieValue = exports.newsletterPopupCookieValue = 'Done';
const newsletterSubscribeCookieKey = exports.newsletterSubscribeCookieKey = 'NewsletterSubscribe';
const newsletterSubscribeCookieValue = exports.newsletterSubscribeCookieValue = 'Done';
const cookieExpireDays = exports.cookieExpireDays = 1;
